<template>
  <v-container class="contract-container pa-0">
    <!-- 캡쳐시 화면 전체 덮는 레이어 -->
    <div v-if="captureMode" class="cover"></div>

    <div class="preview-actions px-4 py-3">
      <v-btn depressed color="primary" :loading="isSavingImage" @click="saveImage">
        이미지 저장
      </v-btn>
    </div>

    <div ref="capture">
      <h3 class="text-center py-4">여신거래계약서</h3>

      <div class="contract-notice mb-9">
        본인은 ㈜펀다에이아이와 아래의 조건에 따라 여신거래를 함에 있어 아래 약관이 적용됨을
        승인하고, 다음 각 조항을 확약합니다.
      </div>

      <ContractExpansionSection
        v-for="(section, index) in sections"
        :key="index"
        :loan="loan"
        :isComplete.sync="section.isComplete"
        :isOpen.sync="section.isOpen"
        :isFocus="section.isFocus"
        :title="section.title"
        :content="section.component"
        :ref="section.refId"
        @complete="navigateNextStep"
      />
    </div>

    <!-- 하단 영역 -->
    <v-footer fixed class="pa-0 ma-0">
      <v-layout>
        <v-btn block depressed tile color="primary" height="52">
          <b class="font-size--18 font-weight-black white--text">다음</b>
        </v-btn>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import html2canvas from 'html2canvas'
import { mapMutations, mapState } from 'vuex'
import { sleep } from '@/util'

export default {
  components: {
    ContractExpansionSection: () =>
      import('@/components/loan/contract/ContractExpansionSection.vue'),
  },
  data() {
    return {
      isSavingImage: false,
      loan: {
        __preview: true,
        amount: '',
        offer: {
          uuid: '',
          periodInDays: '',
          repaymentRatio: '',
          interestRate: '',
          overdueInterestRate: '',
          commissionRate: '',
        },
      },
      sections: [
        {
          isOpen: false,
          isComplete: true,
          title: '채권자 정보',
          component: () => import('@/components/loan/contract/woori-crowd/CreditorInfo.vue'),
        },
        {
          isOpen: true,
          isComplete: false,
          title: '대출자 정보',
          errorMessage: '대출자 정보 확인 버튼을 클릭해주세요.',
          refId: 'DebtorInfo',
          component: () => import('@/components/loan/contract/woori-crowd/DebtorInfo.vue'),
        },
        {
          isOpen: false,
          isComplete: false,
          title: '대출 정보',
          errorMessage: '만기일, 한도 금액, 이율을 작성 및 대출 정보 확인 버튼을 클릭해주세요.',
          refId: 'LoanInfo',
          component: () => import('@/components/loan/contract/woori-crowd/LoanInfo.vue'),
        },
        {
          isOpen: false,
          isComplete: false,
          title: '개인(신용)정보 조회 동의서',
          errorMessage: '개인(신용)정보 조회 동의서에 동의 버튼을 클릭해주세요.',
          refId: 'CreditTerm',
          component: () => import('@/components/loan/contract/woori-crowd/CreditTerm.vue'),
        },
        {
          isOpen: false,
          isComplete: false,
          title: '여신거래 약관 동의',
          errorMessage: '여신거래 약관 확인 버튼 클릭 및 서명해주세요.',
          refId: 'AgreeSign',
          component: () => import('@/components/loan/contract/woori-crowd/AgreeSign.vue'),
        },
      ],
    }
  },
  created() {
    this.setMe({
      name: '',
      birthdate: '',
      phone: '',
      store: {
        name: '',
        businessLicenseNumber: '',
        address1: '',
      },
    })
  },
  computed: {
    ...mapState('ui', ['captureMode']),
  },
  methods: {
    ...mapMutations('auth', ['setMe']),
    ...mapMutations('ui', ['setCaptureMode']),
    navigateNextStep() {
      const incompleteStep = this.sections.find((section) => !section.isComplete)
      if (!incompleteStep) return

      this.sections.forEach((section) => {
        section.isFocus = false
      })
      incompleteStep.isOpen = true
      incompleteStep.isFocus = true
    },
    async saveImage() {
      if (this.isSavingImage) return

      const prevSections = this.sections.map((section) => ({
        section,
        isOpen: section.isOpen,
        isFocus: section.isFocus,
      }))

      try {
        this.isSavingImage = true
        this.setCaptureMode(true)
        this.sections.forEach((section) => {
          section.isOpen = true
          section.isFocus = false
        })
        await sleep(1500)

        const canvas = await html2canvas(this.$refs.capture, {
          backgroundColor: '#ffffff',
          scale: 2,
          useCORS: true,
        })
        const link = document.createElement('a')
        link.href = canvas.toDataURL('image/png')
        link.download = 'contract-preview.png'
        link.click()
      } finally {
        prevSections.forEach(({ section, isOpen, isFocus }) => {
          section.isOpen = isOpen
          section.isFocus = isFocus
        })
        this.setCaptureMode(false)
        this.isSavingImage = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contract-container {
  position: relative;
  padding-bottom: 52px !important;

  .preview-actions {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #ffffff;
    text-align: right;
  }

  .contract-notice {
    background-color: #f4faff;
    padding: 20px;
    font-size: 16px;
    line-height: 1.5;
    color: #333333;
  }
  .cover {
    background-color: transparent;
    position: fixed;
    width: 100%;
    height: 120%;
    top: 0;
    z-index: 3;
    touch-action: none;
  }
}
</style>
